import Vue from 'vue'
import template from './index.pug'
import Frame58 from 'assets/images/info-bono/Frame 58.svg'
import Frame59 from 'assets/images/info-bono/Frame 59.svg'
import Frame61 from 'assets/images/info-bono/Frame 61.svg'
import LogoGE from 'assets/images/logo.svg'
import LogoGC from 'assets/images/logo_prod_GC.png'


export default Vue.extend({
  template: template(), 
  
  components: {
  },

  computed: {
  },

  data() {
    return {
      frame58:Frame58,
      frame59:Frame59,
      frame61:Frame61,
      logoGe:LogoGE,
      logoGc:LogoGC
    }
  },

  methods: {
  }
})